import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isMultiSelect", "isDisabled", "variant", "selectedTopics", "onChange"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useUniqueId from 'hooks/useUniqueId';
import groupBy from 'utils/groupBy';
import Pill from 'components/Pill';
import InlineList from 'components/InlineList';
import Modal from 'components/Modal';
import Flex from 'components/Flex';
import HintTooltip from 'components/HintTooltip';
import Text from 'components/Text';
import Stack from 'components/Stack';
import FormField, { useFormFieldContext } from 'components/FormField';
import TopicSelector from 'screens/TopicSelector';
import AddOrEditButton from './utils/AddOrEditButton';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function TopicList(_ref) {
  var topics = _ref.topics,
    title = _ref.title,
    description = _ref.description;
  var _useFormFieldContext = useFormFieldContext(),
    labelId = _useFormFieldContext.labelId;
  var titleId = useUniqueId();
  if (title) {
    return /*#__PURE__*/_jsxs(Stack, {
      spacing: "xs",
      role: "group",
      "aria-labelledby": titleId,
      children: [/*#__PURE__*/_jsxs(Flex, {
        children: [/*#__PURE__*/_jsx(Text, {
          id: titleId,
          children: title
        }), /*#__PURE__*/_jsx(HintTooltip, {
          content: description,
          spacingLeft: "xs",
          vAlign: false
        })]
      }), /*#__PURE__*/_jsx(InlineList, {
        spacing: "xxs",
        "aria-labelledby": labelId,
        children: topics.map(function (topic) {
          return /*#__PURE__*/_jsx(Pill, {
            icon: "topic",
            children: topic.name
          }, topic.id);
        })
      })]
    });
  }
  return /*#__PURE__*/_jsx(InlineList, {
    spacing: "xxs",
    "aria-labelledby": labelId,
    align: "middle",
    children: topics.map(function (topic) {
      return /*#__PURE__*/_jsx(Pill, {
        icon: "topic",
        children: topic.name
      }, topic.id);
    })
  });
}
function TopicField(_ref2) {
  var _ref2$isMultiSelect = _ref2.isMultiSelect,
    isMultiSelect = _ref2$isMultiSelect === void 0 ? false : _ref2$isMultiSelect,
    isDisabled = _ref2.isDisabled,
    _ref2$variant = _ref2.variant,
    variant = _ref2$variant === void 0 ? 'transparent' : _ref2$variant,
    selectedTopics = _ref2.selectedTopics,
    onChange = _ref2.onChange,
    otherProps = _objectWithoutProperties(_ref2, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isTopicEditorModalOpen = _useState2[0],
    setTopicEditorModalOpen = _useState2[1];
  var _groupBy = groupBy(selectedTopics, function (topic) {
      if (topic.isIndeterminate) {
        return 'indeterminateTopics';
      }
      return 'commonTopics';
    }),
    _groupBy$indeterminat = _groupBy.indeterminateTopics,
    indeterminateTopics = _groupBy$indeterminat === void 0 ? [] : _groupBy$indeterminat,
    _groupBy$commonTopics = _groupBy.commonTopics,
    commonTopics = _groupBy$commonTopics === void 0 ? [] : _groupBy$commonTopics;
  return /*#__PURE__*/_jsxs(FormField, _objectSpread(_objectSpread({
    as: "span",
    label: t('content_type_topic_plural')
  }, otherProps), {}, {
    children: [/*#__PURE__*/_jsxs(Stack, {
      spacing: "xs",
      children: [commonTopics.length > 0 && /*#__PURE__*/_jsx(TopicList, {
        topics: commonTopics,
        title: isMultiSelect ? t('property_common') : undefined,
        description: isMultiSelect ? t('hint_topics_playlist_common', {
          count: commonTopics.length
        }) : undefined
      }), indeterminateTopics.length > 0 && /*#__PURE__*/_jsx(TopicList, {
        title: t('property_individual'),
        description: t('hint_topics_playlist_individual', {
          count: indeterminateTopics.length
        }),
        topics: indeterminateTopics
      }), /*#__PURE__*/_jsx(AddOrEditButton, {
        isEditMode: !!selectedTopics.length,
        addText: t('actions_add_topics'),
        editText: t('actions_edit_topics'),
        variant: variant,
        onClick: function onClick() {
          return setTopicEditorModalOpen(true);
        },
        isDisabled: isDisabled
      })]
    }), isTopicEditorModalOpen && /*#__PURE__*/_jsx(Modal, {
      id: "topic-editor-modal",
      "aria-label": t('actions_assign_topics'),
      onRequestClose: function onRequestClose() {
        return setTopicEditorModalOpen(false);
      },
      children: /*#__PURE__*/_jsx(TopicSelector, {
        initialSelected: selectedTopics,
        initialIndeterminate: indeterminateTopics,
        onChangeSelectedTopics: onChange,
        onClose: function onClose() {
          return setTopicEditorModalOpen(false);
        }
      })
    })]
  }));
}
export default TopicField;